import React, {useEffect, useState} from 'react'
import {useFormik} from 'formik'
import {TextInput} from '../../../../components/inputs/TextInput'
import {createProvenance, editProvenance} from '../../../../components/requests'
import {useNavigate} from 'react-router-dom'

const validate = (values) => {
  const errors: {
    code?: string
    libelle?: string
  } = {}
  if (!values.code) {
    errors.code = 'Le code est requis'
  }
  if (!values.libelle) {
    errors.libelle = 'Le libelle est requis'
  }
  return errors
}

const ProvenanceForm = ({id, data}) => {
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const navigate = useNavigate()

  const insertOrUpdateProvenance = (values) => {
    let action
    if (data === null) {
      action = createProvenance(values)
    } else {
      action = editProvenance(id, values)
    }
    action
      .then((response) => {
        if (response?.data !== undefined && response?.status === 200) {
          setIsLoading(false)
          navigate('/provenances/liste')
        }
      })
      .catch((error) => {
        console.log('erreur')
      })
      .finally(() => {
        setIsLoading(false)
      })
  }

  const submitProvenance = (values) => {
    setIsLoading(true)
    insertOrUpdateProvenance(values)
  }

  useEffect(() => {
    if (data !== null) {
      formik.setFieldValue('libelle', data.libelle)
      formik.setFieldValue('code', data.code)
    }
  }, [data])

  const formik = useFormik({
    initialValues: {
      code: '',
      libelle: '',
    },
    validate,
    onSubmit: (values) => {
      submitProvenance(values)
    },
  })

  return (
    <div>
      <form onSubmit={formik.handleSubmit} noValidate className='form'>
        <div className='card-body border-top p-9'>
          <div className='row mb-6'>
            <label className='col-lg-4 col-form-label required fw-bold fs-6'>Code</label>
            <div className='col-lg-8'>
              <div className='row'>
                <div className='col-lg-6 fv-row'>
                  <TextInput
                    fieldName={'code'}
                    inputPlaceholder={'Code'}
                    inputType={'text'}
                    inputClassName={'form-control form-control-lg form-control-solid mb-3 mb-lg-0'}
                    formik={formik}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className='row mb-6'>
            <label className='col-lg-4 col-form-label required fw-bold fs-6'>Libellé</label>
            <div className='col-lg-8'>
              <div className='row'>
                <div className='col-lg-6 fv-row'>
                  <TextInput
                    fieldName={'libelle'}
                    inputPlaceholder={'Libellé'}
                    inputType={'text'}
                    inputClassName={'form-control form-control-lg form-control-solid mb-3 mb-lg-0'}
                    formik={formik}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className='card-footer d-flex justify-content-end py-6 px-9'>
          <button
            type='button'
            className='btn btn-light me-3'
            onClick={() => {
              formik.resetForm()
              navigate(`/provenances/liste`)
            }}
          >
            Annuler
          </button>
          <button type='submit' className='btn btn-primary'>
            {isLoading ? (
              <span className='indicator-progress' style={{display: 'block'}}>
                Enregistrement...{' '}
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              </span>
            ) : (
              'Enregistrer'
            )}
          </button>
        </div>
      </form>
    </div>
  )
}

export {ProvenanceForm}
